import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import PreviousWeekButton from './PreviousWeekButton';
import NextWeekButton from './NextWeekButton';
import DateOption from './DateOption';
import './weekly-date-picker.scss';
import { weeklyDatePickerFutureDays } from 'app/config';

class WeeklyDatePicker extends React.Component {
  constructor(props) {
    super(props);
    this.getSelectedDate = this.getSelectedDate.bind(this);
    this.getDateOptionsForWeek = this.getDateOptionsForWeek.bind(this);
  }

  getSelectedDate() {
    const { value } = this.props;
    return value || moment().format(moment.HTML5_FMT.DATE);
  }

  getDateOptionsForWeek() {
    const { onChange, dateDataSelector, enabledDateRange } = this.props;
    const selectedDate = this.getSelectedDate();
    const now = moment().add(weeklyDatePickerFutureDays,'days');
    const startDateMoment = moment(selectedDate).startOf('week');
    const endDateMoment = moment(selectedDate).endOf('week');

    const daysOfWeek = [];

    const startDate = moment(enabledDateRange?.startDate);
    const endDate = moment(enabledDateRange?.endDate);

    while (startDateMoment <= endDateMoment) {
      const currentDate = startDateMoment.format(moment.HTML5_FMT.DATE);
      daysOfWeek.push(
        <DateOption
          key={currentDate}
          date={currentDate}
          isSelected={selectedDate === currentDate}
          isDisabled={!enabledDateRange ? moment(currentDate) > now :
            (startDate && moment(currentDate) < startDate) || (endDate && moment(currentDate) > endDate)}
          dateDataSelector={dateDataSelector}
          onChange={onChange} />
      );
      startDateMoment.add(1, 'day');
    }
    return daysOfWeek;
  }

  render() {
    const { onChange, enabledDateRange } = this.props;
    const date = this.getSelectedDate();
    const month = moment(date).format('MMMM');
    const daysOfWeek = this.getDateOptionsForWeek();

    return (
      <div data-testid="weekly-date-picker" className="weekly-date-picker">
        <div data-testid="month" className="row month">{month}</div>
        <div className="row">
          <PreviousWeekButton date={date} onChange={onChange} startDate={enabledDateRange?.startDate} />
          {daysOfWeek}
          <NextWeekButton date={date} onChange={onChange} endDate={enabledDateRange?.endDate} />
        </div>
      </div>
    );
  }
}

WeeklyDatePicker.propTypes = {
  onChange: PropTypes.func.isRequired,
  dateDataSelector: PropTypes.func,
  value: PropTypes.string,
  enabledDateRange: PropTypes.shape({
    startDate: PropTypes.string.isRequired,
    endDate: PropTypes.string.isRequired
  })
};

export default WeeklyDatePicker;
